module.exports = __webpack_public_path__ + "img/tag_20x20.eee497fe.svg";